import React from 'react';
import HalfTextImage from 'shared/half-text-image';

export default function TextImageSplit({ text, image, ...props }) {
  return <HalfTextImage {...{ text, image: image.title, ...props }} />;
}
